export default __webpack_public_path__ + "static/media/purpes 2.07a10710.png";